<div class="flex flex-row justify-center items-center footer mat-body-1 mb-0 fs-12">
  <img src="assets/images/temenos-white-logo.svg" class="logo mr-36">
  <div>{{ 'FOOTER.COPYRIGHT' | transloco : {year: year} }}</div>
  <div class="copyright delimiter"></div>
  <a href="{{Constants.PRIVACY_POLICY_URL}}" target="_blank">{{ 'FOOTER.PRIVACY_POLICY' | transloco }}</a>
  <div class="copyright delimiter"></div>
  <a href="{{Constants.TERMS_AND_CONDITIONS_URL}}" target="_blank">{{ 'FOOTER.TERMS_AND_CONDITIONS' | transloco }}</a>
  <ng-container *ngIf="version">
    <div class="copyright delimiter"></div>
    <span>{{'FOOTER.VERSION' | transloco}}: {{version}}</span>
  </ng-container>  
</div>
